import store from "@packages/store";
import jwtDecode from "jwt-decode";
import Vue from "vue";

export default {
  isTrial: process.env.NODE_ENV === "trial",

  install(Vue) {
    // Add a request interceptor
    Vue.http.interceptors.request.use((request) => {
      if (
        this.token() &&
        !request.headers.Authorization &&
        !request.headers["X-Skip-Auth"]
      )
        this.setAuthHeader(request);

      if (request.headers["X-Skip-Auth"]) delete request.headers["X-Skip-Auth"];

      return request;
    });

    Vue.prototype.$auth = Vue.auth = this;
  },

  token(token) {
    if (!token) return localStorage.getItem("token");

    localStorage.setItem("token", token);

    return this;
  },

  async login(credentials) {
    if (!credentials) return;

    try {
      const loginRes = await Vue.loader.users.login(credentials);

      this.token(loginRes.token);

      const user = jwtDecode(loginRes.token);

      if (this.isIntercomLoaded()) {
        this.setIntercomUser({
          name: user.userName,
          email: user.sub,
          company: {
            name: user.accountName,
            company_id: user.accountId,
          },
          type: user.accountType,
        });
      }

      const isWhitelabel = store.getters["layout/isWhitelabel"];

      if (isWhitelabel) return;

      return user
    } catch (e) {
      this.logout();
    }
  },

  async fetchUserData() {
    if (!this.token) throw new Error("No token available");

    try {
      await Vue.loader.users.user();
    } catch (e) {
      this.logout();
    }
  },

  logout() {
    localStorage.removeItem("token");
    localStorage.removeItem("youtube-api-key");
    store.commit("LOGOUT");

    if (this.isIntercomLoaded()) {
      this.endIntercomSession();
    }
  },

  isIntercomLoaded() {
    return typeof window.Intercom === "function";
  },

  setAuthHeader(request) {
    request.headers.Authorization = this.token();
  },

  setIntercomUser({ name, email, company, type }) {
    if (this.isTrial) {
      return;
    }

    window.Intercom("boot", {
      api_base: "https://api-iam.intercom.io",
      app_id: "xe4wwqi0",
      name,
      email,
      created_at: new Date().getTime(),
      company,
      type,
    });
  },

  endIntercomSession() {
    if (this.isTrial) {
      return;
    }

    window.Intercom("shutdown");
  },

  async refetchLoginData() {
    const youtubeApiKey = localStorage.getItem("youtube-api-key");
    store.commit("SET_ADVERTISING_YT_API_KEY", youtubeApiKey);

    const user = jwtDecode(this.token());
    const isAdmin = user.accountType === "ADMIN";
    const isParceiro = user.accountType === "PARCEIRO";
    const loginAs = localStorage.getItem("loginAs");
    store.commit("SET_LOGIN_AS", loginAs);
    let userData;
    if (isAdmin && loginAs === "false") {
      user.avatar = sessionStorage.getItem("avatar");
      userData = user;
    } else if (isParceiro && user.loggedAs) {
      userData = {
        accountId: user.loggedAs.accountId,
        id: user.loggedAs.userId,
        login: user.loggedAs.sub,
        nome: user.loggedAs.userName,
        permissions: user.loggedAs.permissions,
        tipo: user.loggedAs.accountType,
        avatar: sessionStorage.getItem("avatar-loginAs"),
      };
    } else {
      userData = {
        accountId: user.accountId,
        id: user.userId,
        login: user.sub,
        nome: user.userName,
        permissions: user.permissions,
        tipo: user.accountType,
        avatar: sessionStorage.getItem("avatar"),
        isSsoUser: user.isSsoUser
      };
    }

    if (isAdmin) {
      userData.token = this.token();
    }

    const mutation = user.accountType === "ADMIN" ? "SET_ADMIN" : "SET_USER";

    store.commit(mutation, userData);
    if (isParceiro) store.commit("SET_PARCEIRO", true);

    const isLoggedAs = !!user.loggedAs;

    if (isAdmin && isLoggedAs) {
      store.commit("SET_TOKEN", this.token());

      store.commit("SET_USER", {
        accountId: user.loggedAs.accountId,
        avatar: sessionStorage.getItem("avatar-loginAs"),
        id: user.loggedAs.userId,
        login: user.loggedAs.sub,
        logo: user.logo ? user.logo : "",
        nome: user.loggedAs.userName,
        paginaPosAutenticacao: user.paginaPosAutenticacao,
        permissions: user.loggedAs.permissions,
        isVivoAccount: user.isVivoAccount,
        tipo: user.loggedAs.accountType,
      });
    }
  },
};
